import { SubmissionStakeholder } from './member-submission';
import { CommentMention } from '../base/comment-mention';
import { BaseComment } from '../base/base-comment';

export class SubmissionComment extends BaseComment {
  public memberSubmissionId!: number;
  // Declared on BaseComment as optional; narrowed to required here for submission comments.
  public declare visibleToMember: boolean;
  public mentions: CommentMention[] = [];

  onDeserialize() {
    super.onDeserialize();
    if (!!this.author) {
      this.author = window?.injector?.Deserialize?.instanceOf(SubmissionStakeholder, this.author);
    }
  }
}
